var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.77881 17.2668C5.77881 11.1236 10.7589 6.14355 16.9021 6.14355V6.14355C23.0452 6.14355 28.0253 11.1236 28.0253 17.2668V24.3452C28.0253 25.5224 28.0253 26.1109 27.85 26.581C27.5681 27.3367 26.972 27.9328 26.2163 28.2147C25.7462 28.39 25.1576 28.39 23.9805 28.39H16.9021C10.7589 28.39 5.77881 23.41 5.77881 17.2668V17.2668Z",
    stroke: "#222222",
    strokeWidth: 1.39041
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyChat);
export default __webpack_public_path__ + "static/media/EmptyChat.2d1a7409cff8fb302c5fe7e5089841d1.svg";
export { ForwardRef as ReactComponent };